import {createStyles, Theme, WithStyles, withStyles} from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import {i18n2} from '../../features/i18n/i18n';

interface TitleProps extends WithStyles<typeof styles> {
  title?: string;
  onClose: () => void;
}

const styles = (theme: Theme) =>
  createStyles({
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: 'black',
    },
    title: {
      textAlign: 'center',
    },
  });

const Title = withStyles(styles)(({title, onClose, classes}: TitleProps) => (
  <DialogTitle id="draggable-dialog-title" className={classes.title}>
    <Typography component={'span'} variant={'h6'}>
      {title ? title : i18n2._(`Confirm operation`)}
    </Typography>
    {onClose ? (
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
    ) : null}
  </DialogTitle>
));

export default Title;
